export function formatChange(prev, current) {
  const prevPx = parseFloat(prev);
  const currPx = parseFloat(current);

  if (isNaN(prevPx) || isNaN(currPx)) {
    return { value: "N/A", percent: "N/A" };
  }

  const change = currPx - prevPx;
  const percent = (change / prevPx) * 100;
  const sign = change >= 0 ? "+" : "-";

  return {
    value: `${sign}${Math.abs(change).toFixed(2)}`,
    percent: `${sign}${Math.abs(percent).toFixed(2)}%`,
  };
}

export const toNumber = (value) => {
  if (typeof value === "number") return value;

  return parseFloat(
    String(value)
      .replace("%", "")
      .replace("+", "")
      .trim()
  ) || 0;
};

export function formatPrice(price) {
  if (price >= 1000)
    return (
      "$" +
      price?.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  if (price >= 1) return "$" + price;
  return "$" + price;
}